// cspell:ignore zando
export const omsEngineersBase = [
  "joe",
  "pj",
  "brian",
  "jaden.sterner",
  "jaden",
  "tyson.peterson",
  "tyson",
  "tyler.trommlitz",
  "coleman",
  "coleman.dunn",
  "bcarper",
  "paul",
  "kyle",
  "dev",
  "donovan.smith",
  "zando.ward",
];

export const omsEngineers = omsEngineersBase.flatMap((name) => [
  `${name}@getredo.com`,
  `${name}@redo.com`,
]);

const usersWhoCanChangeBalanceBase = [
  ...omsEngineersBase,
  "dev",
  "suz",
  "aaron",
  "hayden",
  "jackson",
  "aden",
  "kash",
  "josh.thayne",
  "ryan.merrill",
  "dallin.orchard",
  "boston",
  "bryce",
];

const usersWhoCanChangeBalance = [
  ...usersWhoCanChangeBalanceBase.flatMap((name) => [
    `${name}@getredo.com`,
    `${name}@redo.com`,
  ]),
  "ben.kearsley@redo.com",
  "spencer@redo.com",
];

export function canChangeOutboundLabelsBalance(email: string): boolean {
  return usersWhoCanChangeBalance.includes(email);
}
